
class Fab {
    constructor() {
        this.fab = document.getElementById('fab')
        this.isExpanded = false

        if (this.fab === null) {
            return
        }

        this.fabToggle = this.fab.querySelector('button')

        this.init()
    }

    init() {
        this.fabToggle.addEventListener('click', () => this.toggleFab())
        this.fab.addEventListener('click', (e) => e.stopPropagation())

        document.body.addEventListener('click', (event) => {

            if (!this.isExpanded) { return }

            this.toggleFab()

        })

        window.addEventListener('scroll', () => {
            if (!this.isExpanded) {
                return
            }
            this.toggleFab()
        }, { passive: true })

    }

    toggleFab() {
        this.isExpanded = !(this.fabToggle.getAttribute('aria-expanded') === 'true')
        this.fabToggle.setAttribute('aria-expanded', this.isExpanded)
        this.fab.classList.toggle('fab--expanded', this.isExpanded)
    }

}

export default Fab